import request from "../utils/request";
// 单独保存
export const additionalServiceCategoryList = (data) => {
    return request({
        url: "additionalService/category/list ",
        method: "post",
        data
    });
}

// 新增或修改商品信息
export const addAndUpdateitionalService = (data) => {
    return request({
        url: "additionalService/addCategory",
        method: "post",
        data,
    });
}

// 删除附加分类
export const deleteAdditionalCategory = id => {
    return request({
        url: "additionalService/category/remove?id=" + id,
        method: "get",
    });
}

// 获取自定义服务商品列表
export const additionalServiceList = (data) => {
    return request({
        url: "additionalService/service/list",
        method: "post",
        data,
    });
}

// 新增或修改自定义服务
export const addAndUpdateAdditionalService = (data) => {
    return request({
        url: "additionalService/addService",
        method: "post",
        data,
    });
}

// 删除附加服务
export const deleteAdditionalService = id => {
    return request({
        url: "additionalService/service/remove?id=" + id,
        method: "get",
    });
}

// 新增自定义服务订单
export const additionalServiceOrderCreate = (data) => {
    return request({
        url: "additionalService/order/create",
        method: "post",
        data,
    });
}

// 删除附加服务
export const deleteAdditionalServiceOrder = id => {
    return request({
        url: "additionalService/order/remove?id=" + id,
        method: "get",
    });
}

